import { AbacoWebModule, ApplicationReadyEvent } from '@abaco/web-common/src/app';
import globals from "./globals";
import FerreroVuexWidgetModule from './state';
import DashboardChartsModule from "@abaco/dashboard-module/src/modules/charts/index";
import MapWebModule from "@abaco/map-web-module/src/modules/map-web-module/index";
import GlobalStateModule from '@abaco/portal-global-state/src/modules/global-state';
import SsoWebModule, { MODULE_ID as SSO_MODULE_ID } from "@abaco/sso-web-module/src/abaco-module";
import FhcDashboardApi from './api/DashboardApi';
import { HTTPClient } from '@abaco/web-common/src/HTTP';

export const MODULE_ID = "ferrero_widget_module";

export default class FerreroWidgetModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private ssoModule!: SsoWebModule;

    private apiCreated = false;
    private fhcDashboardApi!: FhcDashboardApi;

    readonly id = MODULE_ID;
    readonly globalComponents = globals;
    readonly vuexModule = new FerreroVuexWidgetModule();

    dependsOn = {
        [GlobalStateModule.MODULE_ID]: () => new GlobalStateModule(),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule(),
        [MapWebModule.MODULE_ID]: () => new MapWebModule()
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        const tempModule = evt.modules.find(m => m.id === SSO_MODULE_ID) as SsoWebModule;
        if (!tempModule) {
            throw new Error("SSO Model not found");
        }
        this.ssoModule = tempModule;
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const DashboardApi = (await import("./api/DashboardApi")).default;
        this.fhcDashboardApi = new DashboardApi(http);
    }

    public get FhcDashboardApi(): FhcDashboardApi {
        return this.fhcDashboardApi;
    }
}
